module.exports = __webpack_public_path__ + "static/media/empty.4a7d4e69.png";